export default "__VITE_ASSET__D$Q5bdbN__"